export default __webpack_public_path__ + "ab1b01f197314031b2f29eea15a8cdae.jpg";